import React, { useEffect, useState } from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";

const Timer = ({ targetDate }) => {
    const { t } = useTranslation();

    const calculateTimeLeft = () => {
        const difference = +new Date(targetDate) - +new Date();

        if (difference > 0) {
            return {
                days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(2, '0'),
                hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(2, '0'),
                minutes: String(Math.floor((difference / 1000 / 60) % 60)).padStart(2, '0'),
                seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, '0'),
                isLive: false
            };
        } else {
            return {
                days: '00',
                hours: '00',
                minutes: '00',
                seconds: '00',
                isLive: true
            };
        }
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearInterval(timer);
    }, [targetDate]); // eslint-disable-line


    return (
        <div className={Styles.timerWrap}>
            {timeLeft.isLive ? (
                <div className={Styles.liveNow}>{t('Открыто для участия')}</div>
            ) : (
                <>
                    <div className={Styles.timerBox}>{timeLeft.days}</div>
                    <div className={Styles.timerBox}>{timeLeft.hours}</div>
                    <div className={Styles.timerBox}>{timeLeft.minutes}</div>
                    {/* <div className={Styles.timerBox}>{timeLeft.seconds}</div> */}
                </>
            )}
        </div>
    );
};

export default Timer;